import React from 'react';
import classnames from 'classnames';
import get from 'lodash/get';
import Duperswiper from '../_partials/Duperswiper';
import StageBackground from '../../DeviationBackground/StageBackground';
import CommissionPointsAndPrice from '../../CommissionPointsAndPrice';
import { getDeviationTitle } from '../../DeviationViews/_helpers';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import { formatDollars } from '../../utils/formatting';
import { useMobileStage } from '../hooks/useMobileStage';
import s from './CommissionMobileArtStage.scss';
const CommissionMobileArtStage = ({ className , deviation  })=>{
    const { containerSize  } = useMobileStage(deviation);
    const { commission  } = deviation;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: classnames(className, s['root']),
        "data-hook": BiDataHook.DEVIATION_ART_STAGE
    }, /*#__PURE__*/ React.createElement(Duperswiper, {
        key: deviation.deviationId,
        deviation: deviation,
        height: get(containerSize, 'height'),
        width: get(containerSize, 'width')
    }, (dev)=>/*#__PURE__*/ React.createElement(StageBackground, {
            deviation: dev
        }))), /*#__PURE__*/ React.createElement("div", {
        className: s['title-and-price']
    }, /*#__PURE__*/ React.createElement("h1", {
        className: s['title']
    }, getDeviationTitle(deviation)), /*#__PURE__*/ React.createElement("div", {
        className: s['price']
    }, /*#__PURE__*/ React.createElement(CommissionPointsAndPrice, {
        points: commission.pointsCost,
        price: formatDollars(commission.dollarsCost)
    }))));
};
CommissionMobileArtStage.displayName = 'CommissionMobileArtStage';
export default CommissionMobileArtStage;
